import { AdminApi } from 'stylemix-vue-admin'

export default class CommissionsApi extends AdminApi {
  constructor(parameters) {
    super('company/commissions', parameters)
  }

  process(ids, company_id, param, config = {}) {
    return this.submit(
      'post',
      `/${this.endpoint}/process`,
      { ids: ids || [], company_id },
      config,
    )
  }
}
